import { render, staticRenderFns } from "./frUser.vue?vue&type=template&id=da5af214&scoped=true&"
import script from "./frUser.vue?vue&type=script&lang=js&"
export * from "./frUser.vue?vue&type=script&lang=js&"
import style0 from "./frUser.vue?vue&type=style&index=0&id=da5af214&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5af214",
  null
  
)

export default component.exports